<template>
  <div class="driver-jumpto-wrap">
    <v-menu offset-y max-height="300" v-model="jumpToMenu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          class="jump-to-btn"
          outlined
          v-bind="attrs"
          v-on="on"
        >
          <div>Jump to...</div>
          <div>
            <span v-if="jumpToMenu"><i class="las la-angle-up"></i></span>
            <span v-else><i class="las la-angle-down"></i></span>
          </div>
        </v-btn>
      </template>
      <v-list>
        <div
          v-for="(subdrivers, driver) in interactionDriversList"
          :key="driver"
        >
          <v-list-item @click="jumpToMenu=false;onClickDriver(driver)">
            <v-list-item-title>{{ driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-for="(sd, key) in subdrivers.sub_drivers" :key="key"
            @click.stop="jumpToMenu=false;onClickSubdriver(driver, key)"
          >
            <v-list-item-subtitle class="pl-5 subdriver-target text--black">
              <i>{{ key.replace(/([a-z0-9])([A-Z])/g, '$1 $2') }}</i>
            </v-list-item-subtitle>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
    <!-- <div class="select-box">
      <div class="select-box__current" tabindex="1">
        <div class="select-box__value">
          <input class="select-box__input" type="radio" id="0" value="1" name="Ben" checked="checked"/>
          <p class="select-box__input-text">Jump to...</p>
        </div>
        <img class="select-box__icon" src="http://cdn.onlinewebfonts.com/svg/img_295694.svg" alt="Arrow Icon" aria-hidden="true"/>
      </div>
      <ul class="select-box__list">
        <template v-for="(driver, key) in drivers">
          <li :key="key" :id="driver.driver" @click.stop="selectedDriver=driver.driver;onClickDriver(driver.driver)">
            <label class="select-box__option">{{driver.driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</label>
          </li>
          <template v-for="(subdriver, index) in driver.subdriver">
            <li :key="`sub-${key}${index}`" :id="subdriver" @click.stop="onClickSubdriver(driver.driver, subdriver)">
              <label class="select-box__option">{{subdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</label>
            </li>
          </template>
        </template>
      </ul>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'DriverJumpto',

  data () {
    return {
      jumpToMenu: false,
      interactionDriversList: []
    };
  },

  created () {
    this.getDrivers();
  },

  computed: {
    ...mapState({
      interactionDrivers: state => state.interactionDrivers
    })
  },

  methods: {
    getDrivers () {
      if (this.interactionDrivers && Object.keys(this.interactionDrivers).length > 0) {
        this.interactionDriversList = this.interactionDrivers;
      } else {
        axios.get(`${process.env.VUE_APP_API_URL}reports/driver_enagagement_breakdown`).then((response) => {
          if (response && response.data) {
            this.$store.dispatch('interactionDrivers', response.data);
            this.interactionDriversList = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to get details, Please try again later!'
            });
          }
        });
      }
    },
    onClickDriver (driver) {
      // console.log('onClickSubdriver -> subdriver', driver);
      this.$router.push({
        path: '/drivers/view',
        query: { driver }
      }).catch(() => {});
    },
    onClickSubdriver (driver, subdriver) {
      console.log('onClickSubdriver -> subdriver', subdriver, driver);
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: { subdriver, driver }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.jump-to-btn {
  width: 230px;
  display: flex;
  justify-content: space-between;
  i {
    font-size: 16px !important;
  }
}
.subdriver-target {
  color: var(--color-text) !important;
}
.driver-jumpto-wrap {
  .select-box {
    position: relative;
    display: block;
    width: 250px;
    margin: 0 auto;
    z-index: 2;
    // font-family: 'Open Sans', 'Helvetica Neue', 'Segoe UI', 'Calibri', 'Arial', sans-serif;
    // font-size: 18px;
    // color: #60666d;

    // @media (min-width: 768px) {
    //   width: 70%;
    // }

    // @media (min-width: 992px) {
    //   width: 50%;
    // }

    // @media (min-width: 1200px) {
    //   width: 30%;
    // }
    &__list {
      height: 250px;
      overflow-y: auto;
      overflow-x: hidden;
      border-radius: 0.5rem;
      background-color: var(--bg);
    }
    &__current {
      position: relative;
      box-shadow: 0 15px 30px -10px transparentize(#000, 0.9);
      cursor: pointer;
      outline: none;
      &:focus {
        & + .select-box__list {
          opacity: 1;
          // We have to set "animation-name: none;" to make the list visible (read below how it works)
          animation-name: none;
          .select-box__option {
            cursor: pointer;
          }
        }
        .select-box__icon {
          transform: translateY(-50%) rotate(180deg);
        }
      }
    }

    &__icon {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      width: 20px;
      opacity: 0.3;
      transition: 0.2s ease;
    }

    &__value {
      display: flex;
    }

    &__input {
      display: none;

      &:checked + .select-box__input-text {
        display: block;
        // border-bottom-left-radius: 0rem;
        // border-bottom-right-radius: 0rem;
      }
    }

    &__input-text {
      display: none;
      width: 100%;
      margin: 0;
      padding: 6px 16px;
      border-radius: 0.5rem;
      background-color: #fff;
    }

    &__list {
      position: absolute;
      width: 100%;
      padding: 0;
      list-style: none;
      opacity: 0;

      // We need to use animation with delay.
      // Otherwise the click event will not have time to run on label, because this element disapears immediately when .select-box__current element loses the focus.
      // This delay will not be noticed because we set "opacity" to "0".
      // We also use "animation-fill-mode: forwards" to make the list stay hidden.

      animation-name: HideList;
      animation-duration: 0.5s;
      animation-delay: 0.5s;
      animation-fill-mode: forwards;
      animation-timing-function: step-start;
      box-shadow: 0 15px 30px -10px transparentize(#000, 0.9);
    }

    &__option {
      display: block;
      padding: 15px;
      background-color: #fff;

      &:hover,
      &:focus {
        color: #546c84;
        background-color: #fbfbfb;
      }
    }
  }

  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }
}
</style>
